/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';

/**
 * This components shows the webhook modal form.
 *
 * @vue-prop {String} title the modal title
 * @vue-prop {Object} organization the organization object
 * @vue-prop {Object} [webhook] the optional initial webhook value
 *
 * @category ui.components.organizations
 * @exports WebhookForm
 * @component
 */
const __vue_script__ = {
    name: 'WebhookForm',

    components: { BaseInput, BaseSelect, Checkbox },

    props: {
        title: {
            type: String,
            required: true
        },

        organization: {
            type: Object,
            required: true
        },

        webhook: {
            type: Object,
            default: () => {
                return {
                    label: null,
                    url: null,
                    secret: null,
                    actions: null,
                    active: true
                };
            }
        }
    },

    data() {
        return {
            error: null,
            triggers: ['export', 'erasure', 'unsubscribe', 'event_creation']
        };
    },

    methods: {
        /**
         * Creates the webhook
         */
        async create() {
            const valid = await this.$refs.form.validate();

            if (!valid) { return; }

            try {
                await this.$services.org.saveWebhook(this.organization.name, this.webhook);

                this.$emit('close');

            } catch (error) {
                this.error = error.message;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "webhook-form" },
    [
      _c("validation-observer", {
        ref: "form",
        staticClass: "org-webhook modal-wrapper",
        attrs: { tag: "form", autocomplete: "off" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.create.apply(null, arguments)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var invalid = ref.invalid
              return [
                _c("div", { staticClass: "modal-header" }, [
                  _c("span", {
                    staticClass: "close",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  }),
                  _c("h2", [_vm._v(_vm._s(_vm.$t(_vm.title)))]),
                ]),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c("base-input", {
                      attrs: {
                        label: _vm.$t("webhooks.form.label"),
                        type: "text",
                        name: "label",
                      },
                      model: {
                        value: _vm.webhook.label,
                        callback: function ($$v) {
                          _vm.$set(_vm.webhook, "label", $$v)
                        },
                        expression: "webhook.label",
                      },
                    }),
                    _c("validation-provider", {
                      attrs: {
                        rules: "required|url|secure_scheme",
                        slim: true,
                        name: "url",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("base-input", {
                                  attrs: {
                                    label: _vm.$t("webhooks.form.url"),
                                    type: "text",
                                    name: "url",
                                    errors: errors,
                                    placeholder: _vm.$t(
                                      "webhooks.form.url_placeholder"
                                    ),
                                  },
                                  model: {
                                    value: _vm.webhook.url,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.webhook, "url", $$v)
                                    },
                                    expression: "webhook.url",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("base-input", {
                      attrs: {
                        label: _vm.$t("webhooks.form.secret"),
                        type: "text",
                        name: "secret",
                      },
                      model: {
                        value: _vm.webhook.secret,
                        callback: function ($$v) {
                          _vm.$set(_vm.webhook, "secret", $$v)
                        },
                        expression: "webhook.secret",
                      },
                    }),
                    _c("validation-provider", {
                      attrs: { rules: "required", slim: true, name: "actions" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("base-select", {
                                  attrs: {
                                    label: _vm.$t("webhooks.form.actions"),
                                    options: _vm.triggers,
                                    name: "actions",
                                    errors: errors,
                                    "options-label": null,
                                    multiple: true,
                                  },
                                  model: {
                                    value: _vm.webhook.actions,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.webhook, "actions", $$v)
                                    },
                                    expression: "webhook.actions",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("checkbox", {
                      attrs: {
                        label: _vm.$t("webhooks.form.active"),
                        name: "active",
                        hint: _vm.$t("webhooks.form.active_hint"),
                      },
                      model: {
                        value: _vm.webhook.active,
                        callback: function ($$v) {
                          _vm.$set(_vm.webhook, "active", $$v)
                        },
                        expression: "webhook.active",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "submit" },
                    },
                    [_vm._v(_vm._s(_vm.$t("webhooks.actions.save")))]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm.error
        ? _c("div", { staticClass: "webhook-error modal-wrapper" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("span", {
                staticClass: "close",
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              }),
              _c("h2", [_vm._v(_vm._s(_vm.$t("general.error_occurred")))]),
            ]),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "alert alert-error" }, [
                _vm._v(_vm._s(_vm.error)),
              ]),
            ]),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("general.dismiss")))]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/organizations/WebhookForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__